import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import { makeModal } from './makeModal';
// eslint-disable-next-line @wix/da/create-action-payload-creator
export var pushModal = createAction("".concat(actionPrefix, ".PUSH_MODAL"), makeModal);
// eslint-disable-next-line @wix/da/create-action-payload-creator
export var replaceModal = createAction("".concat(actionPrefix, ".REPLACE_MODAL"), makeModal);
export var popModal = createAction("".concat(actionPrefix, ".POP_MODAL"), function () { return ({}); });
export var removeModalsOfType = createAction("".concat(actionPrefix, ".REMOVE_MODAL_TYPE"), function (type) { return type; });
export var removeModal = createAction("".concat(actionPrefix, ".REMOVE_MODAL"), function (id) { return id; });
//# sourceMappingURL=basicActions.js.map